import { useQuery } from '@tanstack/react-query';
import { getData } from 'services/api';

export interface PartnerData {
	id: number;
	name: string;
	seats_io_secret_key?: string;
	seats_io_workspace_key?: string;
	seats_region?: string;
	stripe_account?: string;
	// Buyer-phone policy: 'off' (don't ask), 'collect' (optional), 'require' (mandatory).
	phone_collection?: 'off' | 'collect' | 'require';
}

const useGetPartnerData = () => {
	const {
		data: partnerData,
		isLoading,
		error,
		refetch,
	} = useQuery({
		queryKey: ['partner-data'],
		queryFn: (): Promise<PartnerData> => getData('/partners/data'),
		staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
		cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
	});

	return {
		partnerData,
		isLoading,
		error,
		refetch,
	};
};

export default useGetPartnerData;
